<template>
    <transition name="modal">
        <div class="dialog-modal-mask">
            <div class="middle-panel" style="height: unset" @click.stop v-if="!showSelectTargetGroup">
                <div class="dialog-title">
                    {{announcementInfo == null ? $t('message.title_announcement_create') : $t('message.title_announcement_edit')}}
                </div>
                <hr class="dialog-hr" />

                <div class="dialog-body">
                    <el-form label-width="170px" class="dialog-form-item">
                        <!--- ベルID --->
                        <el-form-item prop="announcementName" ref="announcementName">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_announcement_edit_label1'"></span>
                                <span class="required" v-t="'message.item_required'"></span>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left" v-html="$t('message.hint_bell_name')"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </div>
                            <el-input id="announcementName" size="large" type="text"
                                      :placeholder="$t('message.place_holder_input_text')" v-model="inputForm.announcementName.value"
                                      clearable :maxlength="MAX_NAME_LENGTH" show-word-limit
                                      @compositionstart.native="compositionStart($event.target.id)"
                                      @compositionend.native="compositionEnd($event.target.id)"
                                      @input.native="inputCheck($event.target.id)" @clear="inputCheck($event.target.id)" />
                        </el-form-item>
                        <!--- 接続先チャンネル --->
                        <el-form-item prop="targetGroup" ref="targetGroup">
                            <div slot="label" style="text-align:left;">
                                <span v-t="'message.item_announcement_edit_label2'"></span>
                                <span class="required" v-t="'message.item_required'"></span>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left" v-html="$t('message.hint_bell_notify_group')"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </div>
                            <el-button style="padding: 10px 20px" @click="openSelectTargetGroup">
                                <span v-t="'message.action_selection'"></span>
                            </el-button>
                            <span class='selected-target-group'>{{ displayEditingTargetGroup }}</span>
                        </el-form-item>
                        <!-- 連続利用時間 -->
                        <el-form-item prop="continuousTime" ref="continuousTime">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_announcement_edit_label3'"></span>
                                <span class="required" v-t="'message.item_required'"></span>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left" v-html="$t('message.hint_bell_notify_lang')"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </div>
                            <el-input id="continuousTime" size="large" type="text"
                                      :placeholder="$t('message.place_holder_input_text')" v-model="inputForm.continuousTime.value"
                                      clearable :maxlength="MAX_NAME_LENGTH" show-word-limit
                                      @compositionstart.native="compositionStart($event.target.id)"
                                      @compositionend.native="compositionEnd($event.target.id)"
                                      @input.native="inputCheck($event.target.id)" @clear="inputCheck($event.target.id)" />
                        </el-form-item>
                        <!-- 履歴取得時間 -->
                        <el-form-item prop="historyTime" ref="historyTime">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_announcement_edit_label4'"></span>
                                <span class="required" v-t="'message.item_required'"></span>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left" v-html="$t('message.hint_bell_notify_lang')"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </div>
                          <el-input id="historyTime" size="large" type="text"
                                    :placeholder="$t('message.place_holder_input_text')" v-model="inputForm.historyTime.value"
                                    clearable :maxlength="MAX_NAME_LENGTH" show-word-limit
                                    @compositionstart.native="compositionStart($event.target.id)"
                                    @compositionend.native="compositionEnd($event.target.id)"
                                    @input.native="inputCheck($event.target.id)" @clear="inputCheck($event.target.id)" />
                        </el-form-item>
                        <!-- 自動読み上げの許可 -->
                        <el-form-item prop="allowAutoSpeak" ref="allowAutoSpeak">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_announcement_edit_label7'"></span>
                                <span class="required" v-t="'message.item_required'"></span>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left" v-html="$t('message.hint_bell_notify_lang')"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </div>
                            <el-radio-group class="ml-4" v-model="inputForm.allowAutoSpeak.value" @change="inputCheck(`selectItem`)">
                                <el-radio :label="true"> {{ $t('message.item_allowed') }} </el-radio>
                                <el-radio :label="false"> {{ $t('message.item_not_allowed') }} </el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <!-- ダークテーマの設定 -->
                        <el-form-item prop="setDarkTheme" ref="setDarkTheme">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_announcement_edit_label8'"></span>
                                <span class="required" v-t="'message.item_required'"></span>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left" v-html="$t('message.hint_bell_notify_lang')"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </div>
                            <el-radio-group class="ml-4" v-model="inputForm.setDarkTheme.value" @change="inputCheck(`selectItem`)">
                                <el-radio :label="true"> {{ $t('message.item_set') }} </el-radio>
                                <el-radio :label="false"> {{ $t('message.item_not_set') }} </el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <!-- 双方向モードの設定 -->
                        <el-form-item prop="interactive" ref="interactive">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_announcement_edit_label10'"></span>
                                <span class="required" v-t="'message.item_required'"></span>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left" v-html="$t('message.hint_bell_notify_lang')"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </div>
                            <el-radio-group class="ml-4" v-model="inputForm.interactive.value" @change="inputCheck(`selectItem`)">
                                <el-radio :label="true"> {{ $t('message.value_on') }} </el-radio>
                                <el-radio :label="false"> {{ $t('message.value_off') }} </el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <!-- 説明文入力 -->
                        <el-form-item prop="explanatoryText" ref="explanatoryText">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_announcement_edit_label9'"></span>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left" v-html="$t('message.hint_bell_notify_lang')"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </div>
                            <el-input id="explanatoryText" size="large" type="textarea"
                                      :placeholder="$t('message.place_holder_input_text')" v-model="inputForm.explanatoryText.value"
                                      clearable :maxlength="explanatoryTextLength" show-word-limit
                                      @compositionstart.native="compositionStart($event.target.id)"
                                      @compositionend.native="compositionEnd($event.target.id)"
                                      @input.native="inputCheck($event.target.id)" @clear="inputCheck($event.target.id)" />
                        </el-form-item>
                        <!--- 利用時間 --->
                        <el-form-item prop="usageTime" ref="usageTime">
                            <div slot="label" style="text-align:left;">
                                <span v-t="'message.item_announcement_edit_label5'"></span>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left" v-html="$t('message.info_bell_usage_time_hint')"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </div>
                            <el-radio-group class="ml-4" v-model="inputForm.usageTime.value.use" @change="inputCheck(`usageTime`)">
                                <el-radio :label="true"> {{ $t('message.item_set') }} </el-radio>
                                <el-radio :label="false"> {{ $t('message.item_not_set') }} </el-radio>
                            </el-radio-group>
                            <div class="time-select-wrapper">
                                <el-time-select
                                    id="usageTimeStart" v-model="inputForm.usageTime.value.range.start"
                                    :disabled="!inputForm.usageTime.value.use"
                                    placeholder=""
                                    :clearable="false"
                                    :picker-options="{ start: '00:00', step: '00:10', end: '24:00' }"
                                    @blur="autoFillUsageTimeIfBlank">
                                </el-time-select>
                                <span> - </span>
                                <el-time-select
                                    id="usageTimeEnd" v-model="inputForm.usageTime.value.range.end"
                                    :disabled="!inputForm.usageTime.value.use"
                                    placeholder=""
                                    :clearable="false"
                                    :picker-options="{ start: '00:00', step: '00:10', end: '24:00' }"
                                    @blur="autoFillUsageTimeIfBlank">
                                </el-time-select>
                            </div>
                        </el-form-item>
                        <!--- 利用地点 --->
                        <el-form-item prop="usagePoint" ref="usagePoint">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_announcement_edit_label6'"></span>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left" v-html="$t('message.info_bell_usage_point_hint')"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </div>
                            <el-radio-group class="ml-4" v-model="inputForm.usagePoint.value.use" @change="inputCheck(`usagePoint`)">
                                <el-radio :label="true"> {{ $t('message.item_set') }} </el-radio>
                                <el-radio :label="false"> {{ $t('message.item_not_set') }} </el-radio>
                            </el-radio-group>
                            <el-input type="text" v-model="inputForm.usagePoint.value.latlng"
                                      maxlength="100" style="width:460px" :disabled="!inputForm.usagePoint.value.use"
                                      :placeholder="$t('message.place_holder_input_latitude')"
                                      @input.native="inputCheck(`usagePoint`)"/>
                        </el-form-item>
                    </el-form>
                </div>
                <hr class="dialog-hr" />
                <div class="dialog-button-field">
                    <el-button class="dialog-cancel-button" type="button" @click="$emit('cancel')"
                               v-t="'message.button_cancel'"></el-button>
                    <el-button class="dialog-ok-button" :disabled="disableButton" @click="saveChange()"
                               v-t="'message.button_save'"></el-button>
                </div>
            </div>

            <SelectTargetGroup v-if="showSelectTargetGroup" :tenantId="appData.tenantList[0].tenantId" :editingGroup="inputForm.targetGroup.value" @none="cancelSelectTargetGroup" @ok="setSelectTargetGroup"></SelectTargetGroup>
        </div>
    </transition>
</template>

<script>
import constants from "../constants";
import commonUtil from '../commonutil.js';
import commonValidate from '../common-validate.js';
import SelectTargetGroup from './AnnouncementSelectTargetGroup.vue';

export default {
    components: {
        SelectTargetGroup,
    },

    props: {
        announcementInfo: Object,
        appData: Object,
    },

    data() {
        return {

            // Fields
            inputForm: {
                announcementName: {
                    validationRule: "announcementName",
                    valid: false,
                    value: null,
                    isComposing: false,
                },
                targetGroup: {
                    validationRule: "require",
                    valid: false,
                    value: null,
                    isComposing: false,
                },
                continuousTime: {
                    validationRule: "require",
                    valid: true,
                    value: 0,
                    isComposing: false,
                },
                historyTime: {
                    validationRule: "require",
                    valid: true,
                    value: 0,
                    isComposing: false,
                },
                allowAutoSpeak: {
                  validationRule: "selectItem",
                  valid: true,
                  value: true,
                  isComposing: false,
                },
                setDarkTheme: {
                    validationRule: "selectItem",
                    valid: true,
                    value: false,
                    isComposing: false,
                },
                explanatoryText: {
                    validationRule: "text",
                    valid: true,
                    value: '',
                    isComposing: false,
                },
                interactive: {
                    validationRule: "selectItem",
                    valid: true,
                    value: false,
                    isComposing: false,
                },
                usageTime: {
                    validationRule: "usageTime",
                    valid: true,
                    value: { use: false, range: { start: '', end: '' } },
                    isComposing: false,
                },
                usagePoint: {
                    validationRule: "usagePoint",
                    valid: true,
                    value: { use: false, latlng: "" },
                    isComposing: false,
                },
            },

            showSelectTargetGroup: false,
            // controllers
            languageList: [],
            explanatoryTextLength: constants.ANNOUNCEMENT_EXPLANATORY_TEXT_LIMIT,
            notificationItems: [],
            disableButton: false,
        };
    },

    computed: {
        constants() {
            return constants
        },
        displayEditingTargetGroup() {
            if (this.inputForm.targetGroup.value == null) {
              return null;
            }
            return this.inputForm.targetGroup.value.talkgroupName;
        }
    },

    created() {
        this.setupData();
        this.setButtonStatus();
    },

    methods: {
        saveChange() {
            // input check
            this.inputCheckAll();
            if (!this.isCheckAllOk()) return;

            if (this.announcementInfo == null) {
                let usageTime;
                if (this.inputForm.usageTime.value.use) {
                    let offset = -(new Date().getTimezoneOffset()); // e.g. +9:00 -> getTimezoneOffset returns -540.
                    usageTime = {
                        start: this.calculateMinutes(this.inputForm.usageTime.value.range.start, -offset),
                        end: this.calculateMinutes(this.inputForm.usageTime.value.range.end, -offset)
                    }
                } else {
                    usageTime = {start: null, end: null}
                }

                let usagePoint;
                if (this.inputForm.usagePoint.value.use) {
                    let parts = this.inputForm.usagePoint.value.latlng.split(',');
                    usagePoint = {latitude: parseFloat(parts[0].trim()), longitude: parseFloat(parts[1].trim())}
                } else {
                    usagePoint = {latitude: null, longitude: null}
                }

                let payload = {
                    name: this.inputForm.announcementName.value,
                    group: this.inputForm.targetGroup.value.talkgroupId,
                    continuousMinutes: this.inputForm.continuousTime.value,
                    historyMinutes: this.inputForm.historyTime.value,
                    allowAutoSpeak: this.inputForm.allowAutoSpeak.value,
                    setDarkTheme: this.inputForm.setDarkTheme.value,
                    explanatoryText: this.inputForm.explanatoryText.value,
                    interactive: this.inputForm.interactive.value,
                    usageTime: usageTime,
                    usagePoint: usagePoint,
                };

                this.$emit("create", payload);

            } else {
                let usageTime;
                if (this.inputForm.usageTime.value.use) {
                    let offset = -(new Date().getTimezoneOffset()); // e.g. +9:00 -> getTimezoneOffset returns -540.
                    usageTime = {
                        start: this.calculateMinutes(this.inputForm.usageTime.value.range.start, -offset),
                        end: this.calculateMinutes(this.inputForm.usageTime.value.range.end, -offset)
                    }
                } else {
                    usageTime = {start: null, end: null}
                }

                let usagePoint;
                if (this.inputForm.usagePoint.value.use) {
                    let parts = this.inputForm.usagePoint.value.latlng.split(',');
                    usagePoint = {latitude: parseFloat(parts[0].trim()), longitude: parseFloat(parts[1].trim())}
                } else {
                    usagePoint = {latitude: null, longitude: null}
                }

                let payload = {
                    id: this.announcementInfo.id,
                    name: this.inputForm.announcementName.value,
                    group: this.inputForm.targetGroup.value.talkgroupId,
                    continuousMinutes: this.inputForm.continuousTime.value,
                    historyMinutes: this.inputForm.historyTime.value,
                    allowAutoSpeak: this.inputForm.allowAutoSpeak.value,
                    setDarkTheme: this.inputForm.setDarkTheme.value,
                    explanatoryText: this.inputForm.explanatoryText.value,
                    interactive: this.inputForm.interactive.value,
                    usageTime: usageTime,
                    usagePoint: usagePoint,
                };

                this.$emit("update", payload);
            }
        },
        openSelectTargetGroup() {
            this.showSelectTargetGroup = true;
        },
        cancelSelectTargetGroup() {
            this.showSelectTargetGroup = false;
        },
        setSelectTargetGroup(tagList) {
            this.showSelectTargetGroup = false;
            let latestEditingGroup = null;
            for (let key in tagList) {
                let tag = tagList[key];
                latestEditingGroup = {
                    talkgroupTenantId: tag.tenantId,
                    talkgroupId: tag.talkgroupId,
                    displayName: tag.displayName,
                    optionFlag: tag.optionFlag,
                    talkgroupName: tag.talkgroupName,
                }
            }
            this.inputForm.targetGroup.value = latestEditingGroup;
            this.inputForm.targetGroup.valid = latestEditingGroup.length !== 0;
            this.setButtonStatus();
        },
        // Component-related
        setupData() {
            if (this.announcementInfo === null) {
                // Add
            } else {
                // Edit
                const {name, group, continuousMinutes, historyMinutes, allowAutoSpeak, setDarkTheme, explanatoryText, interactive, usageTime, usagePoint} = this.announcementInfo;

                this.inputForm.announcementName.value = name;
                this.inputForm.announcementName.valid = true;
                this.inputForm.targetGroup.value = group;
                this.inputForm.targetGroup.valid = true;
                this.inputForm.continuousTime.value = continuousMinutes;
                this.inputForm.historyTime.value = historyMinutes;
                this.inputForm.allowAutoSpeak.value = allowAutoSpeak;
                this.inputForm.interactive.value = interactive;
                this.inputForm.setDarkTheme.value = setDarkTheme;
                this.inputForm.explanatoryText.value = explanatoryText;
                // usage point
                if (usagePoint.latitude && usagePoint.longitude) {
                    this.inputForm.usagePoint.value = {use: true, latlng: `${usagePoint.latitude}, ${usagePoint.longitude}`};
                } else {
                    this.inputForm.usagePoint.value = {use: false, latlng: ""};
                }
                this.inputForm.usagePoint.valid = true;
                // usage time
                if (usageTime.start && usageTime.end && usageTime.start !== usageTime.end) {
                    // Human-friendly notation
                    let offset = -(new Date().getTimezoneOffset());
                    this.inputForm.usageTime.value = { use: true, range: { start: this.calculateMinutes(usageTime.start, offset), end: this.calculateMinutes(usageTime.end, offset) } }
                    if (this.inputForm.usageTime.value.range.start === '24:00') {
                        this.inputForm.usageTime.value.range.start = '00:00';
                    }
                    if (this.inputForm.usageTime.value.range.end === '00:00') {
                        this.inputForm.usageTime.value.range.end = '24:00';
                    }
                } else {
                    this.inputForm.usageTime.value = { use: false, range: { start: "00:00", end: "24:00" } }
                }
                this.inputForm.usageTime.valid = true;
            }
        },
        calculateMinutes(time, minutes) {
            const parts = time.split(':');
            const date = new Date();
            date.setHours(parts[0]);
            date.setMinutes(parts[1]);

            date.setMinutes(date.getMinutes() + minutes);

            const hours = date.getHours().toString().padStart(2, '0');
            const mins = date.getMinutes().toString().padStart(2, '0');
            return `${hours}:${mins}`;
        },
        isCheckAllOk() {
            return commonValidate.checkFormValidation(this.inputForm);
        },
        setButtonStatus() {
            this.disableButton = !commonValidate.checkFormValidation(this.inputForm);
        },
        inputCheck(eventTargetId) {
            if (this.inputForm[eventTargetId].isComposing) {
                // inputting with IME
                return;
            }
            const validateResult = commonValidate.validateItem(this.$i18n, this.inputForm[eventTargetId].validationRule, this.inputForm[eventTargetId].value);
            if (validateResult.valid) {
                this.inputForm[eventTargetId].valid = true;
                if (this.$refs[eventTargetId]) {
                    this.$refs[eventTargetId].clearValidate();
                }
            } else {
                this.inputForm[eventTargetId].valid = false;
                if (this.$refs[eventTargetId]) {
                    this.$refs[eventTargetId].validateState = "error";
                    this.$refs[eventTargetId].validateMessage = validateResult.message;
                }
            }
            this.setButtonStatus();
        },
        inputCheckAll() {
            for (let targetId in this.inputForm) {
                this.inputCheck(targetId);
            }
        },
        compositionStart(eventTargetId) {
            this.inputForm[eventTargetId].isComposing = true;
        },
        compositionEnd(eventTargetId) {
            this.inputForm[eventTargetId].isComposing = false;
            this.inputCheck(eventTargetId)
        },
        autoFillUsageTimeIfBlank() {
            // Human-friendly notation
            if (!this.inputForm.usageTime.value.range.start || this.inputForm.usageTime.value.range.start === "24:00") {
                this.inputForm.usageTime.value.range.start = "00:00";
            }
            if (!this.inputForm.usageTime.value.range.end || this.inputForm.usageTime.value.range.end === "00:00") {
                this.inputForm.usageTime.value.range.end = "24:00";
            }
            this.inputCheck("usageTime");
        }
    }
};
</script>

<style scoped>
.dialog-body {
    max-height: calc(80vh - 170px);
    padding: 20px 30px;
    font-size: 14px;
    overflow: auto;
}
.middle-panel {
    background: #fff;
    position: absolute;
    padding: 0;
    left: 50%;
    top: 50%;
    width: 690px;
    max-height: 80vh;
    margin-top: -40vh;
    margin-left: -345px;
    transition: all .3s ease;
    border-radius: 4px;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
}
.selected-target-group {
    padding-left: 10px;
}
.time-select-wrapper {
    display: flex; /* Makes the wrapper a flex container */
    align-items: center; /* Vertically aligns items in the center */
    margin-top: 10px; /* Optional: Adds some space between the radio group and time select */
}
.time-select-wrapper > * {
    margin-right: 5px; /* Optional: Adds some space between the time select elements */
}
</style>
